import type { MapType, MapCreateType, MapUpdateDataType } from './types';
import { MapCreateSchema, MapSchema, MapUpdateDataSchema } from './types';
import { z } from 'zod';
import { Api } from '@automapa/svelte-automapa-template';

export class MapApi {
    // https://lm.nemo.indigo/docs/#req_b015afc661174788ab672d372154a1e4
    public static async getAll(api: Api): Promise<MapType[]> {
        return api.getData<undefined, MapType[]>(
            'get',
            '/maps',
            undefined,
            z.undefined(),
            z.array(MapSchema)
        );
    }

    // https://lm.nemo.indigo/docs/#req_10efc3853b0643098a7ab4c04f5768fe
    public static async getOne(api: Api, mapId: number): Promise<MapType> {
        return api.getData<undefined, MapType>(
            'get',
            `/map/${mapId}`,
            undefined,
            z.undefined(),
            MapSchema
        );
    }

    // https://lm.nemo.indigo/docs/#req_a413554e810b415aafbd81c172bac29f
    public static async create(api: Api, map: MapCreateType): Promise<MapType> {
        return api.getData<MapCreateType, MapType>('post', '/map', map, MapCreateSchema, MapSchema);
    }

    public static async removeOne(api: Api, mapId: number): Promise<any> {
        return api.delete(`/map/${mapId}`);
        // return api.getData<undefined,any>(
        //     'delete',
        //     `/map/${mapId}`,
        //     undefined,
        //     z.undefined(),
        //     z.any()
        // );
    }

    public static async updateZones(api: Api, mapId: number, data: MapUpdateDataType) {
        return api.getData(
            'post',
            `/map/${mapId}/update_zones`,
            data,
            MapUpdateDataSchema,
            z.any()
        );
    }

    public static async prepareZonesForEdit(api: Api, mapId: number) {
        return api.getData(
            'post',
            `/map/${mapId}/prepare_zones_for_edit`,
            {},
            z.any(),
            z.any()
        );
    }

    public static async deepcopy(api: Api, mapId: number): Promise<MapType> {
        return api.getData<any, MapType>(
            'post',
            `/map/${mapId}/deepcopy`,
            {},
            z.object({}),
            MapSchema
        );
    }
}
